let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7rXzl")).then(() => parcelRequire('g8c95'));